/**
 * TanStack Query configuration for products
 * Centralized query keys and options
 */

import { queryOptions } from "@tanstack/react-query";
import {
  buildSearchBody,
  fetchProducts,
  SearchQuery,
  SearchRequestBody,
} from "@/lib/api/products";
import { SearchUrlParams } from "@/lib/models/search";

/**
 * Query keys factory
 * Helps organize and identify cached queries
 */
export const productsQueryKeys = {
  all: ["products"] as const,
  lists: () => [...productsQueryKeys.all, "list"] as const,
  list: (body: SearchRequestBody) =>
    [...productsQueryKeys.lists(), body] as const,
};

/**
 * Query options for fetching products list
 * Can be used with useQuery or with prefetchQuery for SSR
 */
export const getProductsQueryOptions = (
  searchQuery?: SearchQuery | SearchUrlParams,
  page: number = 0,
  pageSize: number = 30,
  filters?: Record<string, string[]>,
) =>
  queryOptions({
    // La llave usa el cuerpo ya limpio: un parámetro ajeno de la URL
    // (utm_source, etc.) no crea otra entrada de caché.
    queryKey: productsQueryKeys.list(
      buildSearchBody(searchQuery, page, pageSize, filters),
    ),
    queryFn: () => fetchProducts(searchQuery, page, pageSize, filters),
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
  });
